module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin22-df204a7b675f2a61ffed6821edef6b24.jpg";